import { createSlice } from '@reduxjs/toolkit'
import { selectAllContracts } from './selectors'

const initialState = {
	data: [],
	showModal: false,
	showLinkModal: false,
	showStripeModal: false,
	link: '',
	pages: {
		page: 0,
		per_page: 0,
		total: 0,
	},
	error: null,
	loading: false,
	parent: null,
	order: null,
	order_by: null,
}

const { actions, reducer } = createSlice({
	name: 'contract',
	initialState,
	reducers: {
		listContract: (state) => {
			state.loading = true
		},
		listContractSuccess: (state, action) => {
			state.data = selectAllContracts(action.payload.items)
			state.pages = {
				page: action.payload.page,
				per_page: action.payload.per_page,
				total: action.payload.total,
			}
			state.error = null
			state.loading = false
			state.parent = action.payload.parent
			state.order = action.payload.order
			state.order_by = action.payload.order_by
		},
		listContractFailure: (state, action) => {
			state.error = action.payload.error
			state.loading = false
		},
		createLink: (state) => {
			state.loading = true
			state.showModal = false
		},
		createLinkSuccess: (state, { payload }) => {
			state.link = payload.link
			state.showLinkModal = true
			state.error = null
			state.loading = false
		},
		createLinkFailure: (state, { payload }) => {
			state.error = payload.error
			state.loading = false
		},
		deleteContract: (state) => {
			state.loading = true
		},
		deleteFolder: (state) => {
			state.loading = true
		},
		deleteSelected: (state) => {
			state.loading = true
		},
		deleteSuccess: (state, { payload }) => {
			state.data = selectAllContracts(payload.items)
			state.pages = {
				page: payload.page,
				per_page: payload.per_page,
				total: payload.total,
			}
			state.error = null
			state.loading = false
		},
		deleteFailure: (state, { payload }) => {
			state.error = payload.error
			state.loading = false
		},
		viewContract: (state) => state,
		setShowModal: (state, { payload }) => {
			state.showModal = payload
		},
		setShowLinkModal: (state, { payload }) => {
			state.showLinkModal = payload
		},
		setShowStripeModal: (state, { payload }) => {
			state.showStripeModal = payload
		},
	},
})

export const {
	listContract,
	createLink,
	createLinkSuccess,
	createLinkFailure,
	deleteContract,
	deleteFolder,
	deleteSelected,
	deleteSuccess,
	deleteFailure,
	listContractSuccess,
	listContractFailure,
	viewContract,
	setShowModal,
	setShowLinkModal,
	setShowStripeModal,
} = actions

export { default as contractSaga } from './sagas'

export default reducer
